function showRecoverPasswordForm() {
  document.getElementById('customer-recover-password').style.display = 'block';
  document.getElementById('customer-login').style.display='none';
  // a11y: move focus into the revealed form (WCAG 2.4.3)
  var recoverInput = document.querySelector('#customer-recover-password input.email');
  if (recoverInput) recoverInput.focus();
}
function hideRecoverPasswordForm() {
  document.getElementById('customer-recover-password').style.display = 'none';
  document.getElementById('customer-login').style.display = 'block';
  var loginInput = document.querySelector('#customer-login input.email');
  if (loginInput) loginInput.focus();
}
if (window.location.hash.indexOf('recover') > 0) {
  showRecoverPasswordForm();
  if ($s.getQueryParam('email')) {
    document.querySelector('#customer-recover-password input.email').value = $s.getQueryParam('email');
  }
}

document.querySelectorAll('.customer-form-page form').forEach((form)=>{
  form.addEventListener('submit', (e)=>{
    var error = false;
    form.querySelectorAll('.error').forEach((element)=>{
      element.classList.remove('error');
      element.removeAttribute('aria-invalid');
    });
    form.querySelectorAll('.required').forEach((element)=>{
      if(element.value=="") {
        error = true;
        element.classList.add('error');
        element.setAttribute('aria-invalid', 'true');
        form.querySelector('.error-msg').innerHTML = lngg.general__forms__complete_all_the_fields_message;
      }
    });
    if(!error && form.querySelector('.email')) {
      if(!$s.validateEmail(form.querySelector('.email').value)) {
        error = true;
        form.querySelector('.email').classList.add('error');
        form.querySelector('.email').setAttribute('aria-invalid', 'true');
        form.querySelector('.error-msg').innerHTML = lngg.general__forms__enter_a_valid_email_message;
      }
    }
    if(!error && form.querySelector('[name="customer[password_confirmation]"]')) {
      if(form.querySelector('[name="customer[password]"]').value != form.querySelector('[name="customer[password_confirmation]"]').value) {
        error = true;
        form.querySelector('[name="customer[password_confirmation]"]').classList.add('error');
        form.querySelector('[name="customer[password_confirmation]"]').setAttribute('aria-invalid', 'true');
        form.querySelector('.error-msg').innerHTML = lngg.general__forms__confirmation_password_must_match_message;
      }
    }
    if(error) {
      e.preventDefault();
      e.stopImmediatePropagation();
      form.querySelector('.error-msg').style.display = 'block';
      // a11y: move focus to the first invalid field so the error is actionable (WCAG 3.3.1)
      var firstError = form.querySelector('.error');
      if (firstError) firstError.focus();
      return false;
    }
  });
});
